export enum FundingSource {
    insurerAgreement = 'insurerAgreement',
    nzaSubTrack = 'nzaSubTrack',
}
